<bdeo-drawer #drawer closable overlay [headerTitle]="'baskets.edit_result' | i18nextEager">
  <div [formGroup]="basketForm" class="basket-edit-wrapper">
    <bdeo-select
      [error]="!basketForm.valid"
      size="medium"
      type="form"
      [label]="'brokers:baskets.result' | i18nextEager"
      [placeholder]="'brokers:baskets.result' | i18nextEager"
      [options]="basketOptions"
      formControlName="selectedBasket"
      ngDefaultControl
    ></bdeo-select>
  </div>

  <app-footer selectorForPadding=".add-wrapper">
    <bdeo-button
      data-test-id="save-basket"
      type="primary"
      [icon]="isSaving ? 'loading-circle' : 'check-check'"
      [text]="'brokers:actions.save' | i18nextEager"
      [disabled]="!basketForm.valid || basketForm.pristine || isSaving"
      (click)="save()"
    ></bdeo-button>
    <bdeo-button
      data-test-id="cancel-basket"
      type="secondary"
      skin="ghost"
      [disabled]="isSaving"
      [text]="'brokers:actions.transaction_reject' | i18nextEager"
      (click)="close()"
    ></bdeo-button>
  </app-footer>
</bdeo-drawer>
